export default __webpack_public_path__ + "static/media/hero.e1f89215.png";